module.exports = __webpack_public_path__ + "static/media/Prep-Logo.3366623c.png";